import React, { useEffect, useState, useCallback } from 'react';
// @ts-ignore
import { DateTime } from 'luxon';
import { useUserUtilitiesClockSettings } from 'components/utils/UserUtilitiesApiEndpoints';
import { GenericSwr } from './useGenericSWR.interfaces';
import { API_CONFIG } from 'utils/constants/api.constants';

interface UserUtilitiesContextType {
    clock: DateTime;
    clockSettings: GenericSwr | null;
}

interface UserUtilitiesProviderProps {
    children: React.ReactNode;
}

const defaultState = {
    clock: DateTime.now(),
    clockSettings: null
};

export const UserUtilitiesContext = React.createContext<UserUtilitiesContextType>(defaultState);

export const UserUtilitiesProvider = (props: UserUtilitiesProviderProps) => {
    const [clock, setClock] = useState(defaultState.clock);
    const clockSettings = useUserUtilitiesClockSettings(clock);

    const updateClock = useCallback(() => {
        setClock(DateTime.now());
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setClock(DateTime.now());
        }, API_CONFIG.cache_expiration_milliseconds);

        const handleVisibilityChange = () => {
            if (!document.hidden) {
                updateClock();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [updateClock]);

    const providerValue = React.useMemo(() => ({
        clock: clock,
        clockSettings: clockSettings
    }), [clock, clockSettings]);

    return (
        <UserUtilitiesContext.Provider value={providerValue}>
            {props.children}
        </UserUtilitiesContext.Provider>
    );
};